import { css, styled } from '@bob/library'

interface AssetWrapperProps {
  width?: string | number
  height?: string | number
  disableUpscale: boolean
}

export const Wrapper = styled.div<AssetWrapperProps>`
  position: relative;
  overflow: hidden;

  ${({ height, width }: AssetWrapperProps) =>
    height &&
    width &&
    css`
      ${typeof height === 'number' &&
      typeof width === 'number' &&
      `padding-bottom: ${(height / width) * 100}%`};

      & > img {
        position: absolute;
      }
    `}

  & img {
    ${({ disableUpscale }: AssetWrapperProps) =>
      disableUpscale
        ? css`
            max-width: 100%;
          `
        : css`
            width: 100%;
          `}
  }
`
